<template>
  <div class="lp-step bg-people-blur">
    <div class="lp-popup">
      <div
        class="step-title"
        style="z-index: 2; position: relative;"
      >
        {{ $t('lps.What do you want women to call you?') }}
      </div>
      <validation-observer
        ref="form"
        #default="{invalid}"
      >
        <b-form
          class="auth-login-form"
          @submit.prevent="formSubmitted"
        >
          <b-row>
            <b-col md="12">
              <b-form-group
                label-for="userName"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t('Username')"
                  vid="userName"
                  rules="required"
                >
                  <b-spinner
                    v-if="userNameChecking"
                    style="position: absolute; right: 8px"
                    small
                    class="m-1"
                    type="grow"
                  />
                  <b-form-input
                    id="userName"
                    v-model="userName"
                    :placeholder="$t('Username')"
                    :disabled="userNameChecking"
                    class="placeholder-black"
                    :state="errors.length > 0 ? false : (userNameAvailable || null)"
                    @focusout="checkUsername"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                  <small
                    v-if="userNameAvailable"
                    class="text-success"
                  >
                    {{ $t('Username is available') }}
                  </small>
                  <p class="mt-1 text-center fs-12">
                    {{ $t('lps.Name can be changed at any time.') }}
                  </p>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-button
                class="mt-0"
                type="submit"
                variant="primary"
                block
                style="background-color: #AC33F4 !important; color: #fff !important; padding: 16px; border-radius: 16px;"
                :disabled="loading || invalid || !userNameAvailable"
              >
                <b-spinner
                  v-if="loading"
                  small
                />
                {{ $t('Next') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'Lp3Step3',
  components: {
    BButton,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BSpinner,

    ValidationObserver,
    ValidationProvider,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      userName: '',
      userNameAvailable: false,
      userNameChanged: false,
      userNameChecking: false,
      userNameCheckingDelay: 1000,
      userNameCheckingTimeout: null,
    }
  },
  methods: {
    checkUsername() {
      if (this.userName !== '') {
        this.userNameChecking = true
        this.userNameChanged = true
        useJwt.checkUsername({ username: this.userName, lang: this.$i18n.locale })
          .then(() => {
            this.userNameAvailable = true
          })
          .catch(() => {
            this.userNameAvailable = false
            this.$refs.form.setErrors({
              userName: this.$t('You cannot use this username'),
            })
          })
          .finally(() => {
            this.userNameChanged = false
            this.userNameChecking = false
          })
      }
    },
    formSubmitted() {
      if (this.userNameAvailable) {
        this.$emit('setUsername', this.userName)
        this.$emit('nextStep')
      } else {
        this.checkUsername()
      }
    },
  },
}
</script>
